import React, { useEffect, useCallback } from 'react';

import styles from './Toolbar.scss';
import { connect } from 'react-redux';
import { __ } from '../../../../core/utils';
import { withRouter } from 'react-router';
import Select from '../Select';
import Line from '../Line';
import Arrow from '../Arrow';
import ReactDOM from 'react-dom';

import Ellipse from '../Ellipse';
import Rect from '../Rect';

import Polygon from '../Polygon';
import Cloud from '../Cloud';
import Delete from '../Delete';
import Task from '../Task/Task';
import Color from '../Color/Color';
import Thickness from '../Thickness/Thickness';
import Pencil from '../Draw/Pencil';
import Highlighter from '../Draw/Highlighter';
import Hand from '../Hand/Hand';
import Plan from '../Plan/Plan';

import Specification from '../Specification/Specification';
import { updateTool } from '../../../../redux/actions/canvas_editor';
import { OSDTools } from './OSDTools';
import Textbox from '../Textbox';

const Toolbar = ({
  canvas_editor: { viewer, activeTool },
  source,
  sourceType,
}) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      updateTool({ tool: 'hand' });
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  const drawingTools = (
    <>
      <Line
        isActive={activeTool === 'line'}
        source={source}
        sourceType={sourceType}
      />
      <Arrow
        isActive={activeTool === 'arrow'}
        source={source}
        sourceType={sourceType}
      />
      <Pencil
        isActive={activeTool === 'pencil'}
        source={source}
        sourceType={sourceType}
      />
      <Highlighter
        isActive={activeTool === 'highlighter'}
        source={source}
        sourceType={sourceType}
      />
      <Ellipse
        isActive={activeTool === 'ellipse'}
        source={source}
        sourceType={sourceType}
      />
      <Textbox
        isActive={activeTool === 'textbox'}
        source={source}
        sourceType={sourceType}
      />
      <Rect
        isActive={activeTool === 'rect'}
        source={source}
        sourceType={sourceType}
      />
      <Polygon isActive={activeTool === 'polygon'} source={source} />
      <Cloud isActive={activeTool === 'cloud'} source={source} />

      <Color />
      <Thickness />
    </>
  );

  const planTools = (
    <>
      <Task isActive={activeTool === 'task'} source={source} />
      <Plan isActive={activeTool === 'plan'} source={source} />
      <Specification
        isActive={activeTool === 'specification'}
        source={source}
      />
    </>
  );

  if (!source || !viewer?.canvas) return <></>;

  return (
    viewer &&
    ReactDOM.createPortal(
      <div className={styles.OSDToolbar}>
        <Hand source={source} />

        <Select source={source} />

        {(sourceType != 'image' || viewer.isFullPage()) && (
          <OSDTools viewer={viewer} />
        )}

        {sourceType != 'image' && planTools}

        {drawingTools}

        <Delete />
      </div>,
      viewer?.container
    )
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
  };
};

export default withRouter(connect(mapStateToProps, null)(Toolbar));
